export default __webpack_public_path__ + "static/media/19.0491acbf.png";